import React, { FC, ReactElement } from 'react'
import styles from './UtxoItem.module.css'
import useExchangeRate from '@/utils/hooks/useExchangeRate'
import classNames from 'classnames'
import Radio from '@mui/material/Radio'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const SelectUtxoItem: FC<{ utxo: any; onSelect: (o: string) => void; selected: boolean }> = (
	props
): ReactElement => {
	const { utxo, onSelect, selected } = props
	const { exchangeRate } = useExchangeRate()

	return (
		<div
			className={styles.root}
			onClick={() => onSelect(utxo.outpoint)}
			role="button"
			tabIndex={0}
			onKeyDown={onKeyboardClick(() => onSelect(utxo.outpoint))}
		>
			<Radio
				checked={selected}
				value="a"
				name="radio-buttons"
				inputProps={{ 'aria-label': 'A' }}
				sx={{
					color: 'rgba(208, 213, 221, 1)',
					'&.Mui-checked': {
						color: 'rgba(182, 146, 246, 1)'
					}
				}}
			/>

			<div className={styles.body}>
				<div className={classNames(styles.btc, 'text-md', 'bold')}>
					{(utxo.value / 1e8).toFixed(8)}
				</div>
				<div className={classNames(styles.usd, 'text-sm', 'regular')}>
					~${((utxo.value / 1e8) * exchangeRate).toFixed(2)}
				</div>
			</div>
		</div>
	)
}

export default SelectUtxoItem
